import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import { RESPONSE_LIST_CANNED_PROMPTS } from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import { CannedPrompt } from "userful-chronos-app-common-js/dist/models/eisenhower/agent/agents";
import eisenhowerStore from "../eisenhowerStore";
import { eisenhowerActions } from "../eisenhowerSlice";

registerMsgHandler(RESPONSE_LIST_CANNED_PROMPTS, (payload) => {
    console.debug("receive RESPONSE_LIST_CANNED_PROMPTS");
    const data = JSON.parse(payload) as CannedPrompt[];
    eisenhowerStore.dispatch(eisenhowerActions.setCannedPrompts(data));
});
